// extracted by mini-css-extract-plugin
export default {"button":"requestInviteView_button__sbJI5","highlight":"requestInviteView_highlight__8xXRE"};